import { siteClock } from './siteClock';
// Extract a valid schedule date from a URL query string.
// Returns YYYY-MM-DD if `?date=` is present and parseable, otherwise `fallback`
// (defaults to today in Atlanta).
//
// Kept as a tiny pure helper so it's trivially unit-testable — the Schedule page's
// useState initializer inlines the same logic so mount cost stays at zero.
export function scheduleDateFromQuery(search, fallback = siteClock().date) {
  const q = new URLSearchParams(search || "").get("date");
  if (q && /^\d{4}-\d{2}-\d{2}$/.test(q) && !Number.isNaN(Date.parse(q))) return q;
  return fallback;
}
